import React, { useRef } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { vsClose } from '@deephaven/icons';
import Button from "./Button.js";
import ThemeExport from "./ThemeExport.js";
import "./ToastNotification.css";
import { FadeTransition } from "./transitions/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ToastNotification(_ref) {
  var buttons = _ref.buttons,
    _ref$isShown = _ref.isShown,
    isShown = _ref$isShown === void 0 ? false : _ref$isShown,
    classNamesProp = _ref.classNames,
    message = _ref.message,
    type = _ref.type,
    onClick = _ref.onClick,
    onDismiss = _ref.onDismiss,
    dataTestId = _ref['data-testid'];
  var nodeRef = useRef(null);
  var hasButtons = buttons && buttons.length !== 0;
  return /*#__PURE__*/_jsx(CSSTransition, {
    in: isShown,
    timeout: ThemeExport.transitionMs,
    classNames: "toast-notification-slide-up",
    mountOnEnter: true,
    unmountOnExit: true,
    nodeRef: nodeRef,
    children: /*#__PURE__*/_jsxs("div", {
      ref: nodeRef,
      className: classNames('toast-notification', classNamesProp, type),
      role: "presentation",
      onClick: onClick,
      onKeyPress: onClick,
      "data-testid": dataTestId,
      children: [/*#__PURE__*/_jsx("div", {
        className: "message-container",
        children: /*#__PURE__*/_jsx("span", {
          className: "message",
          children: message
        })
      }), /*#__PURE__*/_jsx(FadeTransition, {
        in: hasButtons,
        timeout: ThemeExport.transitionSlowMs,
        mountOnEnter: true,
        unmountOnExit: true,
        children: /*#__PURE__*/_jsx("div", {
          className: "buttons-container",
          children: buttons
        })
      }), onDismiss && /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        icon: vsClose,
        tooltip: "Close notification",
        className: "my-2",
        onClick: onDismiss
      })]
    })
  });
}
ToastNotification.TYPE = Object.freeze({
  ERROR: 'error'
});
export default ToastNotification;
//# sourceMappingURL=ToastNotification.js.map